import React from 'react';
import { componentService } from 'js/services/component.service';

export const LottoApp = React.lazy(() => import(/* webpackChunkName: "lotto-app" */ './LottoApp'));

componentService.registerPageComponents({ 'lotto-app': LottoApp });
